<div class="otp-verify">
  <h4 class="text-primary">Please verify your OTP to open the chat:</h4>
  <input type="text" class="input-text-box" [(ngModel)]="secondCode" placeholder="Phone last 4 digits" [maxLength]="4" required>
  <input type="text" class="input-text-box" [(ngModel)]="otpCode" placeholder="OTP Code" [maxLength]="4" required>
  <div>
    <button type="submit" class="submit-btn" [disabled]="loadingRequest" (click)="verifyOTP()">Open Chat</button>
    @if(loadingRequest){
      <span class="dots-loader"></span>
    }
  </div>
  <span class="otp-error-txt text-error">{{otpVerifyError}}</span>
</div>